import { FormField } from "@/modules/irohana-components/elements/FormField";
import { Input } from "@/modules/irohana-components/elements/Input";
import { SealPreview } from "@/features/user-settings/components/SealPreview";
import { TUserSettingDetail } from "@/api/services/main/user-setting/dtos/get-user-setting.dto";
import { MAX_INVOICE_SEAL_DISPLAY_NAME_LENGTH } from "@/constants/common";
import { getSealDisplayName, TUserSettingForm } from "@/features/user-settings/types/user-setting-form";
import { text } from "@/theme/colors";
import { spacing } from "@/theme/variables";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";

type TSealSectionProps = {
  detail?: TUserSettingDetail;
  readOnly?: boolean;
};

const PreviewBlock: FC<{ value?: string }> = ({ value }) => (
  <Stack gap={0.5} alignItems="flex-start">
    <Typography variant="cap12" color={text.secondary}>
      プレビュー
    </Typography>
    <SealPreview value={value} />
  </Stack>
);

const SealEditField: FC = () => {
  const { control } = useFormContext<TUserSettingForm>();
  const value = useWatch<TUserSettingForm>({ name: "invoiceSealDisplayName" });

  return (
    <Stack direction="row" alignItems="flex-end" gap={spacing.md}>
      <FormField name="invoiceSealDisplayName" label="押印表示名（最大4文字まで）" control={control} sx={{ width: "fit-content", flexShrink: 0 }}>
        <Input clearable placeholder="入力してください" inputProps={{ maxLength: MAX_INVOICE_SEAL_DISPLAY_NAME_LENGTH }} sx={{ width: 163 }} />
      </FormField>
      <PreviewBlock value={typeof value === "string" ? value : ""} />
    </Stack>
  );
};

export const SealSection: FC<TSealSectionProps> = ({ detail, readOnly = false }) => {
  if (readOnly) {
    return <PreviewBlock value={getSealDisplayName(detail)} />;
  }
  return <SealEditField />;
};
